import _getBlockRenderMap from './block/blockRenderMap'
import _getBlockRendererFn from './block/blockRendererFn'
import _getBlockStyleFn from './block/blockStyleFn'
import _getCustomStyleMap from './inline/inlineStyleMap'
import _getCustomStyleFn from './inline/inlineStyleFn'
import _getDecorators from './decorators'

export const getBlockRenderMap = _getBlockRenderMap
export const getBlockRendererFn = _getBlockRendererFn
export const getBlockStyleFn = _getBlockStyleFn
export const getCustomStyleMap = _getCustomStyleMap
export const getCustomStyleFn = _getCustomStyleFn
export const getDecorators = _getDecorators